const t = {
  type: "text",
  size: "medium"
};
export { t as textInputDefaultProps };